export interface IFiltersData {
  id: string;
  title: string;
  value: string;
}

export const buyersFiltersData: Array<IFiltersData> = [
  {id: '1', title: 'جدیدترین', value: 'lastest'},
  {id: '2', title: 'نزدیک‌ترین ', value: 'nearest'},
];
export const buyersSelectData: Array<IFiltersData> = [
  {id: '1', title: 'فروش فوری', value: 'isUrgent'},
];
